import { Check, Circle } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

export interface PasswordRequirement {
  key: string;
  label: string;
  met: boolean;
}

export interface PasswordRequirementsChecklistProps {
  requirements: PasswordRequirement[];
  /** Optional heading shown above the list. */
  heading?: string;
  className?: string;
}

export function PasswordRequirementsChecklist({
  requirements,
  heading,
  className,
}: PasswordRequirementsChecklistProps) {
  return (
    <div className={cn('space-y-2', className)}>
      {heading && (
        <div className="text-xs font-medium text-foreground" aria-hidden="true">
          {heading}
        </div>
      )}
      <ul
        className="space-y-1"
        aria-live="polite"
        aria-label={heading}
      >
        {requirements.map((req) => (
          <li
            key={req.key}
            className={cn(
              'flex items-center gap-2 text-xs transition-colors',
              req.met ? 'text-green-600 dark:text-green-500' : 'text-muted-foreground'
            )}
          >
            {req.met ? (
              <Check
                className="h-3.5 w-3.5 flex-shrink-0"
                aria-hidden="true"
                strokeWidth={3}
              />
            ) : (
              <Circle
                className="h-3.5 w-3.5 flex-shrink-0"
                aria-hidden="true"
              />
            )}
            <span>
              <span className="sr-only">
                {req.met ? 'Cumplido: ' : 'Pendiente: '}
              </span>
              {req.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
